"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ME_RESULT_TYPE = exports.RAW_META_EXPRESSION_KEY_STRIPPED = exports.RAW_META_EXPRESSION_KEY = exports.META_EXPRESSION_TARGET_TYPE = exports.META_EXPRESSION_SCOPE = exports.__ME_STEP_CURRENT_WORKFLOW__ = void 0;
exports.__ME_STEP_CURRENT_WORKFLOW__ = "__current___workflow__field__";
var META_EXPRESSION_SCOPE;
(function (META_EXPRESSION_SCOPE) {
    META_EXPRESSION_SCOPE["ITEM"] = "ITEM";
    META_EXPRESSION_SCOPE["ACTIVITY_REPORT"] = "ACTIVITY_REPORT";
    META_EXPRESSION_SCOPE["JOB_REPORT"] = "JOB_REPORT";
    META_EXPRESSION_SCOPE["WORKFLOW_REPORT"] = "WORKFLOW_REPORT";
    META_EXPRESSION_SCOPE["CLIENT"] = "CLIENT";
    META_EXPRESSION_SCOPE["USER"] = "USER";
    META_EXPRESSION_SCOPE["CUSTOMER"] = "CUSTOMER";
    META_EXPRESSION_SCOPE["ITEM_CELL"] = "ITEM_CELL";
    META_EXPRESSION_SCOPE["MATRIX_CELL"] = "MATRIX_CELL";
    META_EXPRESSION_SCOPE["TRANSFORMATION"] = "TRANSFORMATION";
    META_EXPRESSION_SCOPE["INTEG_RECORD"] = "INTEG_RECORD";
    META_EXPRESSION_SCOPE["TRIGGER_EVENT"] = "TRIGGER_EVENT";
})(META_EXPRESSION_SCOPE || (exports.META_EXPRESSION_SCOPE = META_EXPRESSION_SCOPE = {}));
var META_EXPRESSION_TARGET_TYPE;
(function (META_EXPRESSION_TARGET_TYPE) {
    META_EXPRESSION_TARGET_TYPE["SQL"] = "SQL";
    META_EXPRESSION_TARGET_TYPE["TEXT"] = "TEXT";
    META_EXPRESSION_TARGET_TYPE["VARIABLE"] = "VARIABLE";
})(META_EXPRESSION_TARGET_TYPE || (exports.META_EXPRESSION_TARGET_TYPE = META_EXPRESSION_TARGET_TYPE = {}));
var RAW_META_EXPRESSION_KEY;
(function (RAW_META_EXPRESSION_KEY) {
    RAW_META_EXPRESSION_KEY["FIELD"] = "__field";
    RAW_META_EXPRESSION_KEY["CUSTOM_FIELD"] = "__custom_field";
    RAW_META_EXPRESSION_KEY["OPTION_TAG"] = "__option_tag";
    RAW_META_EXPRESSION_KEY["STEP"] = "__step";
})(RAW_META_EXPRESSION_KEY || (exports.RAW_META_EXPRESSION_KEY = RAW_META_EXPRESSION_KEY = {}));
// This should be programmatically derived from RAW_META_EXPRESSION_KEY (or the other way round)
// See stripMetaExpressionKey
var RAW_META_EXPRESSION_KEY_STRIPPED;
(function (RAW_META_EXPRESSION_KEY_STRIPPED) {
    RAW_META_EXPRESSION_KEY_STRIPPED["FIELD"] = "field";
    RAW_META_EXPRESSION_KEY_STRIPPED["CUSTOM_FIELD"] = "custom_field";
    RAW_META_EXPRESSION_KEY_STRIPPED["OPTION_TAG"] = "option_tag";
    RAW_META_EXPRESSION_KEY_STRIPPED["STEP"] = "step";
})(RAW_META_EXPRESSION_KEY_STRIPPED || (exports.RAW_META_EXPRESSION_KEY_STRIPPED = RAW_META_EXPRESSION_KEY_STRIPPED = {}));
var ME_RESULT_TYPE;
(function (ME_RESULT_TYPE) {
    ME_RESULT_TYPE["NO_RESULT"] = "no_result";
    ME_RESULT_TYPE["FIELD_RESULT"] = "field_result";
    ME_RESULT_TYPE["CUSTOM_FIELD_RESULT"] = "custom_field_result";
    ME_RESULT_TYPE["MATRIX_ITERATION_RESULT"] = "matrix_iteration_result";
})(ME_RESULT_TYPE || (exports.ME_RESULT_TYPE = ME_RESULT_TYPE = {}));
